import { defineRecipe } from '@chakra-ui/react';

export const buttonRecipe = defineRecipe({
  base: {
    borderRadius: '2px',
    fontWeight: 'medium',
  },
  variants: {
    variant: {
      nav: {
        fontWeight: 'normal',
        width: '100%',
        height: '44px',
        justifyContent: 'flex-start',
        borderRadius: '8px',
        px: '2.5',
        bg: 'transparent',
        color: 'neutral.0',
        '&[data-expanded="false"]': {
          minWidth: '45px',
          width: '45px',
          alignSelf: 'center',
        },
        _hover: {
          bg: 'neutral.0/10',
        },
        _active: {
          bg: 'neutral.0/10',
          '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: '10px',
            bottom: 0,
            borderRadius: '4px',
            width: '4px',
            height: '24px',
            background: 'neonGreen.500',
          },
        },
      },
      disabled: {
        border: '2px',
        borderRadius: '4px',
        borderColor: '#B7BAC5',
        textColor: '#B7BAC5',
        bgColor: 'white',
      },
      outline: {
        fontWeight: 'medium',
        borderColor: 'colorPalette.500',
        color: 'colorPalette.500',
        _hover: {
          bg: 'colorPalette.50',
        },
        _active: {
          bg: 'colorPalette.100',
        },
        _disabled: {
          borderColor: 'neutral.200',
          color: 'neutral.200',
          _hover: {
            bg: 'neutral.0',
          },
        },
      },
      solid: {
        fontWeight: '500',
        _hover: {
          bg: 'colorPalette.400',
        },
        _active: {
          bg: 'colorPalette.600',
        },
        _disabled: {
          bg: 'neutral.50',
          color: 'neutral.250',
          _hover: {
            bg: 'neutral.50',
            color: 'neutral.250',
          },
        },
      },
    },
    size: {
      lg: {
        h: 12,
        textStyle: 'lg',
        gap: 2,
        px: 4,
        minW: '150px',
        _icon: {
          width: '6',
          height: '6',
        },
      },
      md: {
        h: 10,
        gap: 2,
        px: 4,
        minW: '130px',
        _icon: {
          width: '5',
          height: '5',
        },
      },
      sm: {
        h: 8,
        gap: 2,
        px: 2,
        minW: '114px',
        _icon: {
          width: '5',
          height: '5',
        },
      },
      xs: {
        h: 6,
        gap: 2,
        px: 2,
        minW: '50px',
        _icon: {
          width: '5',
          height: '5',
        },
      },
    },
  },
  compoundVariants: [
    {
      size: 'lg',
      variant: 'outline',
      css: {
        borderWidth: '2px',
      },
    },
    {
      size: 'md',
      variant: 'outline',
      css: {
        borderWidth: '2px',
      },
    },
    {
      variant: 'outline',
      colorPalette: 'neutral' as never,
      css: {
        borderColor: 'neutral.200',
        color: 'neutral.500',
        _hover: {
          bg: 'neutral.50',
        },
        _active: {
          bg: 'neutral.100',
        },
        _disabled: {
          bg: 'neutral.0',
        },
      },
    },
    {
      variant: 'solid',
      colorPalette: 'neutral' as never,
      css: {
        backgroundColor: 'neutral.100',
        color: 'neutral.500',
        _hover: {
          bg: 'neutral.50',
        },
        _active: {
          bg: 'neutral.200',
        },
        _disabled: {
          backgroundColor: 'neutral.100',
        },
      },
    },
  ],
  defaultVariants: {
    size: 'sm',
  },
});
